// Auth
import { runWithAdal } from 'react-adal';
import { authContext } from './config/azureConfig';
import './i18n';

const DO_NOT_LOGIN = true;

runWithAdal(
  authContext,
  () => { require('./reduxApp'); },
  DO_NOT_LOGIN
);
  